import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalStory } from '../components/EmotionalStory';
import { BenefitsSection } from '../components/BenefitsSection';
import { BundleSection } from '../components/BundleSection';
import { BonusSection } from '../components/BonusSection';
import { TargetAudience } from '../components/TargetAudience';
import { PricingCTA } from '../components/PricingCTA';
import { TestimonialFooter } from '../components/TestimonialFooter';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-144">
      <HeroSection data-id="element-145" />
      <EmotionalStory data-id="element-146" />
      <BenefitsSection data-id="element-147" />
      <BundleSection data-id="element-148" />
      <BonusSection data-id="element-149" />
      <TargetAudience data-id="element-150" />
      <PricingCTA data-id="element-151" />
      <TestimonialFooter data-id="element-152" />
    </main>;
}